import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './core';

// 忽略自定义元素标签抛出的报错
Vue.config.ignoredElements = [
  'wx-open-launch-app',
  'wx-open-audio',
  'wx-open-launch-weapp',
];

Vue.config.productionTip = false;

// 初始化实例
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
